import { type FC } from 'react';
import { useHeatmapFormInitialStyle } from '~/store/frontendState/mapTools/heatmap/heatmapForm.selectors';
import { useSpreadsheetColumns } from '~/store/matchupData/matchupDataSelectors.hook';
import {
  HeatMapPanelFormComponent, type HeatMapPanelSubmitItem,
} from './heatMapPanelForm.component';

type HeatMapPanelFormProps = Readonly<{
  onSubmit: (item: HeatMapPanelSubmitItem) => void;
}>;

export const HeatMapPanelFormContainer: FC<HeatMapPanelFormProps> = props => {
  const columns = useSpreadsheetColumns();
  const initialStyle = useHeatmapFormInitialStyle();

  return (
    <HeatMapPanelFormComponent
      onSubmit={props.onSubmit}
      selectableColumns={columns}
      initialStyle={initialStyle ?? undefined}
    />
  );
};
